module.exports = __webpack_public_path__ + "img/robot1.93310976.png";